/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type VerifyDocumentDto = {
    /**
     * Action to take on the document
     */
    action: VerifyDocumentDto.action;
    /**
     * Rejection reason (required when action is reject or request_resubmission)
     */
    rejectionReason?: string;
};
export namespace VerifyDocumentDto {
    /**
     * Action to take on the document
     */
    export enum action {
        APPROVE = 'approve',
        REJECT = 'reject',
        REQUEST_RESUBMISSION = 'request_resubmission',
    }
}

